
import $ from 'jquery';
import _ from 'lodash';
import ko from 'rgs-knockout';
import window from 'window';

import Velocity from 'rgs-velocity-animate';

import { ContextBarContent } from './content.js';
import template from '../templates/button-scroll-to-top.html';

const SCROLL_DEBOUNCE_TIME = 500;

export class ContentButtonScrollToTop extends ContextBarContent {
	constructor (options) {

		const offsetVisibility = ko.observable(false);

		options = _.defaultsDeep(options || {}, {
			name: 'button-scroll-up',
			visible: () => offsetVisibility(),
		});

		super(options);

		this.priority = Number(-Infinity);

		this.template = {
			html: template(),
			data: this,
		};

		this.cssClasses = {
			'btn-scroll-to-top': true,
		};

		this.offsetVisibility = offsetVisibility;

		this.scrollResponse = null;

		this._init();
	}

	_init = () => {
		this._setEventListeners();
		this._handleOffset();
	}

	_setEventListeners = () => {
		window.addEventListener('scroll', this._handleOffset);
	}

	_handleOffset = () => {
		clearTimeout(this.scrollResponse);
		this.scrollResponse = setTimeout(() => {
			const height = window.outerHeight;
			const offset = window.pageYOffset;
		
			this.offsetVisibility(offset > (height * 2));
		}, SCROLL_DEBOUNCE_TIME);
	}

	scrollToTop = () => {
		Velocity.animate($('body'), 'scroll');
	}

	dispose = () => {
		window.removeEventListener('scroll', this._handleOffset);
	}
}